import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Feather, Sparkles, LifeBuoy, Wand2, Compass } from "lucide-react";

export default function WelcomeDialog({ open, onOpenChange, name, onStartTour }) {
  const first = (name || "").trim().split(" ")[0];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="welcome-dialog" className="sm:max-w-md overflow-hidden p-0">
        <div className="bg-[#12100c] px-6 pt-8 pb-6 text-center relative">
          <div className="w-14 h-14 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-4">
            <Feather className="w-7 h-7 text-primary-foreground" />
          </div>
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-bold text-white">
              {first ? `Welcome aboard, ${first}!` : "Welcome to CodexStudio!"}
            </DialogTitle>
            <DialogDescription className="text-white/70 mt-1">
              Thank you for joining — your writing studio is ready.
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="px-6 py-5 space-y-4">
          <div className="flex items-start gap-3" data-testid="welcome-updates">
            <div className="w-9 h-9 shrink-0 rounded-lg bg-secondary flex items-center justify-center">
              <Wand2 className="w-4.5 h-4.5 text-primary" />
            </div>
            <div>
              <p className="text-sm font-semibold">We're always improving</p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                CodexStudio is actively developed — features get tweaked, polished and
                added routinely, so expect things to keep getting better.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3" data-testid="welcome-support">
            <div className="w-9 h-9 shrink-0 rounded-lg bg-secondary flex items-center justify-center">
              <LifeBuoy className="w-4.5 h-4.5 text-primary" />
            </div>
            <div>
              <p className="text-sm font-semibold">Hit a snag? We're here</p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Found a problem or have an idea? Open the menu under your{" "}
                <span className="font-semibold text-foreground">avatar</span> (top-right)
                and choose <span className="font-semibold text-foreground">“Get help”</span>{" "}
                to message us directly.
              </p>
            </div>
          </div>
        </div>

        <DialogFooter className="px-6 pb-6 flex-col sm:flex-col gap-2">
          <Button
            data-testid="welcome-tour-button"
            className="w-full h-11 text-base font-semibold"
            onClick={() => { onOpenChange(false); onStartTour?.(); }}
          >
            <Compass className="w-4 h-4 mr-2" /> Take a quick tour
          </Button>
          <Button
            data-testid="welcome-start-button"
            variant="ghost"
            className="w-full h-10"
            onClick={() => onOpenChange(false)}
          >
            Skip for now — I'll explore
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
